import { useEffect, useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  const itemList = crumbs
    .map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.label,
      ...(c.to ? { item: `https://mangao0.github.io${c.to}` } : {}),
    }));

  return (
    <nav aria-label="面包屑" className="mx-auto w-full max-w-6xl px-4 pt-6 md:px-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        {crumbs.map((c, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>}
            {c.to ? (
              <Link to={c.to} className="transition-colors hover:text-primary-600">{c.label}</Link>
            ) : (
              <span className="text-foreground-800">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: itemList,
        })}
      </script>
    </nav>
  );
}

export default function Layout({ children, title }: { children: ReactNode; title: string }) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1" id="main">
        {children}
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:-translate-y-1"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}